"use strict";

var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _client = require("@apollo/client");
var _reactRouterDom = require("react-router-dom");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _generateStyle = _interopRequireDefault(require("./utils/generateStyle"));
var _selectMenu = _interopRequireDefault(require("./components/selectMenu"));
var _textBox = _interopRequireDefault(require("./components/textBox"));
var _getRedirectType = _interopRequireDefault(require("./utils/getRedirectType"));
var _useQuery = _interopRequireDefault(require("./hooks/useQuery"));
var _getAvailableArms = _interopRequireDefault(require("./utils/getAvailableArms"));
var _isDisabledMember = _interopRequireDefault(require("./utils/isDisabledMember"));
var _setDefaultValues = _interopRequireDefault(require("./utils/setDefaultValues"));
var _generateNotification = _interopRequireDefault(require("./utils/generateNotification"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
/* DataAccessRequest coponenent */
function DataAccessRequest(_ref) {
  var data = _ref.data,
    formFields = _ref.formFields,
    pageTitle = _ref.pageTitle,
    SUBMIT_REQUEST_ACCESS = _ref.SUBMIT_REQUEST_ACCESS,
    bentoHelpEmail = _ref.bentoHelpEmail,
    custodianUtils = _ref.custodianUtils,
    notification = _ref.notification,
    styles = _ref.styles,
    AlertMessage = _ref.AlertMessage;
  /* styles */
  var generatedStyle = (0, _generateStyle.default)(styles);
  var useStyles = (0, _styles.makeStyles)(generatedStyle);
  var classes = useStyles();

  /* Component states */
  var _ref2 = (0, _react.useState)(true),
    _ref3 = _slicedToArray(_ref2, 2),
    disableSubmit = _ref3[0],
    setDisableSubmit = _ref3[1];
  var _ref4 = (0, _react.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    isFormSubmitted = _ref5[0],
    setSubmitted = _ref5[1];
  var _ref6 = (0, _react.useState)(false),
    _ref7 = _slicedToArray(_ref6, 2),
    showDisabledAlert = _ref7[0],
    setShowDisabledAlert = _ref7[1];
  /* hooks */
  var history = (0, _reactRouterDom.useHistory)();
  var query = (0, _useQuery.default)();
  var _ref8 = (0, _client.useMutation)(SUBMIT_REQUEST_ACCESS, {
      context: {
        clientName: 'userService'
      },
      onCompleted: function onCompleted() {
        // INPUT parm can be 'responseData'
        setSubmitted(true);
      },
      onError: function onError() {
        // INPUT parm can be 'ApolloError'
      }
    }),
    _ref9 = _slicedToArray(_ref8, 2),
    mutate = _ref9[0],
    response = _ref9[1];
  /* variables */
  var getMyUser = data.getMyUser,
    listArms = data.listArms;
  var userEmail = getMyUser.email,
    IDP = getMyUser.IDP,
    role = getMyUser.role,
    userStatus = getMyUser.userStatus;
  var redirectdType = (0, _getRedirectType.default)(query);
  var getAuthenticatorName = custodianUtils.getAuthenticatorName,
    capitalizeFirstLetter = custodianUtils.capitalizeFirstLetter;
  var loading = response.loading,
    error = response.error,
    successData = response.data;
  var availableArms = (0, _getAvailableArms.default)(getMyUser.acl, listArms);
  var fieldsToChk = formFields.map(function (field) {
    return field.required ? field.id : null;
  });
  var _ref10 = (0, _react.useState)((0, _setDefaultValues.default)(formFields, getMyUser, availableArms)),
    _ref11 = _slicedToArray(_ref10, 2),
    formValues = _ref11[0],
    setFormValues = _ref11[1];
  /* event handlers */
  var isInputDisabled = function isInputDisabled() {
    return isFormSubmitted || availableArms.length <= 0;
  };
  var getErrorDetails = function getErrorDetails() {
    var _error$networkError = error.networkError,
      errors = _error$networkError.result.errors,
      statusCode = _error$networkError.statusCode;
    if (statusCode !== 409) {
      return 'Server Error';
    }

    // Return API error message for disabled members
    if ((0, _isDisabledMember.default)(role, userStatus)) {
      return errors[0].error;
    }

    // Default error message
    return 'The request arm does not exist or attempting to request an invalid ARM';
  };
  var showAlert = function showAlert(alertType) {
    var notificationSchema = (0, _generateNotification.default)(notification);
    switch (alertType) {
      case 'error':
        return /*#__PURE__*/_react.default.createElement(AlertMessage, {
          severity: "error",
          backgroundColor: notificationSchema.error.color
        }, notificationSchema.error.message ? notificationSchema.error.message : getErrorDetails());
      case 'success':
        return /*#__PURE__*/_react.default.createElement(AlertMessage, {
          severity: "success",
          backgroundColor: notificationSchema.success.color
        }, notificationSchema.success.message);
      case 'noAclToRequest':
        return /*#__PURE__*/_react.default.createElement(AlertMessage, {
          severity: "error",
          backgroundColor: notificationSchema.noAclToRequest.color
        }, notificationSchema.noAclToRequest.message);
      case 'noAccess':
        return /*#__PURE__*/_react.default.createElement(AlertMessage, {
          severity: "success",
          timeout: 5000000,
          backgroundColor: notificationSchema.noAccess.color
        }, notificationSchema.noAccess.message);
      case 'disabled':
        return /*#__PURE__*/_react.default.createElement(AlertMessage, {
          severity: "error",
          timeout: 5000000,
          backgroundColor: notificationSchema.disabled.color
        }, notificationSchema.disabled.message);
      default:
        return null;
    }
  };
  var validateFields = function validateFields() {
    // First check if any arms available for selection?
    // This function is useful when page is loaded and no arms are available.
    if (availableArms.length <= 0) {
      setDisableSubmit(true);
      return;
    }

    // if not cehck form values are corrct or not.
    var validInputValues = fieldsToChk.reduce(function (status, field) {
      var fieldValue = formValues[field];
      return fieldValue.length >= 1 && status;
    }, true);
    if (validInputValues) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  };
  var handleInputChange = function handleInputChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFormValues(_objectSpread(_objectSpread({}, formValues), {}, _defineProperty2({}, name, value)));
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var userInfo = formValues;
    if (userStatus !== 'Disabled') {
      mutate({
        variables: {
          userInfo: userInfo
        }
      });
    } else if (userStatus === 'Disabled') {
      setShowDisabledAlert(true);
    }
  };
  function redirectUser(path) {
    history.push(path);
  }
  function isACLAvailable() {
    return availableArms.length > 0;
  }
  function getNotification(isDisabledAlert) {
    if (error) {
      return showAlert('error');
    }
    if (!isACLAvailable()) {
      return showAlert('noAclToRequest');
    }
    if (successData && successData.requestAccess) {
      return showAlert('success');
    }
    if (redirectdType && redirectdType === 'noAccess') {
      return showAlert(redirectdType);
    }
    if (userStatus === 'Disabled' && isDisabledAlert) {
      return showAlert('disabled');
    }
    return null;
  }

  /* useEffect hooks */
  (0, _react.useEffect)(validateFields);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.Container
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    justifyContent: "center",
    className: classes.emptySpace
  }, getNotification(showDisabledAlert)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 2
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 8,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 4
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 4,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.pageTitle
  }, pageTitle, /*#__PURE__*/_react.default.createElement("hr", {
    className: classes.pageTitleUnderline
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 4
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 4
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 4,
    direction: "row",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.brace
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.SummaryBox
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.column
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.itemTitles
  }, "Account Type:")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.column
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.itemValue
  }, getAuthenticatorName(IDP || '')))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.column
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.itemTitles
  }, "Email Address:")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.column
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.itemValue
  }, ' ', userEmail, ' '))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.column
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.itemTitles
  }, " Membership Status: ")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.column
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.itemValue
  }, ' ', userStatus === '' ? 'N/A' : capitalizeFirstLetter(userStatus), ' ')))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.brace
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 4
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.Box
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "center",
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, formFields.map(function (field) {
    if (!field.display) {
      return null;
    }
    switch (field.type) {
      case 'aclDropdown':
        return (0, _selectMenu.default)(field, formValues, handleInputChange, data, classes, availableArms, isInputDisabled());
      case 'dropdown':
        return (0, _selectMenu.default)(field, formValues, handleInputChange, data, classes, availableArms, isInputDisabled());
      case 'textBox':
        return (0, _textBox.default)(field, formValues, handleInputChange, classes, isInputDisabled());
      default:
        return null;
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    sm: 12,
    style: {
      textAlign: 'center',
      marginTop: '19px'
    },
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.requiredFieldMessage
  }, "* denotes  required field")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    sm: 12,
    style: {
      textAlign: 'center'
    },
    justifyContent: "center"
  }, isFormSubmitted ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    className: [classes.formButton, classes.goToHomeButton],
    endIcon: loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
      color: "secondary",
      size: 20
    }) : null,
    onClick: function onClick() {
      return redirectUser('/');
    }
  }, "Go Back To Home Page") : /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    type: "submit",
    className: [classes.formButton, classes.submitButton],
    disabled: disableSubmit,
    endIcon: loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
      color: "secondary",
      size: 20
    }) : null
  }, "Submit")))))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 2
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.helperMessage
  }, "If you have any questions about access or the registration process, please contact", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: classes.supportEmail
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:".concat(bentoHelpEmail)
  }, bentoHelpEmail))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    justifyContent: "center",
    className: classes.emptySpace
  }));
}
var _default = DataAccessRequest;
exports.default = _default;